import React from 'react';
import { useTranslation } from 'react-i18next';
import { RulerHorizontalIcon } from '@radix-ui/react-icons';
import { TextInput } from '@/shared/ui';
import type { PropertyFilters } from './constants';
import { SectionHeader, FieldLabel, QtyBtn } from './parts';

interface Props {
  filters: PropertyFilters;
  setFilters: (f: PropertyFilters) => void;
}

/** Renders building-related filters: year built, floor, and total rooms. */
export const FilterSectionBuilding: React.FC<Props> = ({ filters, setFilters }) => {
  const { t } = useTranslation('features/properties');
  return (
    <div>
      <SectionHeader icon={<RulerHorizontalIcon width={14} height={14} />} title={t('filterPanel.building')} />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'var(--space-2)' }}>
          <div>
            <FieldLabel>{t('filterPanel.yearBuiltMin')}</FieldLabel>
            <TextInput
              placeholder="1980"
              value={filters.yearBuiltMin || ''}
              onChange={(e) => setFilters({ ...filters, yearBuiltMin: e.target.value })}
            />
          </div>
          <div>
            <FieldLabel>{t('filterPanel.yearBuiltMax')}</FieldLabel>
            <TextInput
              placeholder="2026"
              value={filters.yearBuiltMax || ''}
              onChange={(e) => setFilters({ ...filters, yearBuiltMax: e.target.value })}
            />
          </div>
          <div>
            <FieldLabel>{t('filterPanel.floorMin')}</FieldLabel>
            <TextInput
              placeholder="1"
              value={filters.floorMin || ''}
              onChange={(e) => setFilters({ ...filters, floorMin: e.target.value })}
            />
          </div>
          <div>
            <FieldLabel>{t('filterPanel.floorMax')}</FieldLabel>
            <TextInput
              placeholder="30"
              value={filters.floorMax || ''}
              onChange={(e) => setFilters({ ...filters, floorMax: e.target.value })}
            />
          </div>
        </div>
        <div>
          <FieldLabel>{t('filterPanel.totalRooms')}</FieldLabel>
          <div style={{ display: 'flex', gap: 'var(--space-1)' }}>
            {['1','2','3','4','5+'].map((n) => (
              <QtyBtn key={`rooms-${n}`} value={n} active={filters.totalRooms === n} onClick={() => setFilters({ ...filters, totalRooms: filters.totalRooms === n ? undefined : n })} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
